export default __webpack_public_path__ + "static/media/13_CAMP_OUGANDA_03-min.1b53a7cd.jpg";